import { useState } from "react";
import { Flag, PenLine, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

const SCREENS = [
  { icon: PenLine, title: "Middle is for facts", text: "You can only post Facts here: what happened, with numbers, places and dates. Middle checks each one against its approved sources and shows whether they corroborate it. Opinions and personal updates can't be posted." },
  { icon: RefreshCw, title: "Re-check any fact", text: "Evidence moves on. Tap a Fact's status and choose 'Re-check this fact' to have Middle compare it with the latest approved sources again." },
  { icon: Flag, title: "Spot something wrong? Tell Middle", text: "Use 'Suggest a correction' on any Fact or Middle Live page. Middle's AI checks your correction against approved sources; if they confirm it, it's fixed straight away. Your verified Facts and corrections are counted on a badge only you (and Middle's admins) can see." },
];

// Three short screens before the usual setup; Skip goes straight to setup.
export const FactsIntro = ({ onDone }) => {
  const [i, setI] = useState(0);
  const s = SCREENS[i];
  const last = i === SCREENS.length - 1;
  return (
    <div className="space-y-6 fade-up" key={i} data-testid={`welcome-intro-${i}`}>
      <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-emerald-50 text-[hsl(var(--facts))]"><s.icon size={26} /></span>
      <h1 className="text-4xl font-medium tracking-tight sm:text-5xl">{s.title}</h1>
      <p className="max-w-xl text-lg leading-relaxed text-slate-600">{s.text}</p>
      <div className="flex items-center gap-3">
        <div className="flex gap-1.5">{SCREENS.map((_, k) => <span key={k} className={`h-1.5 rounded-full transition-all ${k === i ? "w-6 bg-slate-900" : "w-1.5 bg-slate-300"}`} />)}</div>
        <Button variant="ghost" className="ml-auto rounded-full" onClick={onDone} data-testid="welcome-intro-skip">Skip</Button>
        <Button className="rounded-full px-7" onClick={() => (last ? onDone() : setI(i + 1))} data-testid="welcome-intro-next">{last ? "Set up my account" : "Next"}</Button>
      </div>
    </div>
  );
};
